import React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

const GrohmannFooterCopy = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <div>
      <h3>{formatMessage(messages.AboutTeslaHeader)}</h3>
      <p>{formatMessage(messages.AboutTeslaOne)}</p>
      <p>{formatMessage(messages.AboutTeslaTwo)}</p>
      <p>{formatMessage(messages.AboutTeslaThree)}</p>
      <p>{formatMessage(messages.AboutTeslaFour)}</p>
      <p className="disclaimer">{formatMessage(messages.EqualOpportunityOne)}</p>
    </div>
  );
};

export default GrohmannFooterCopy;
